import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
import ChevronUpIcon from "@dcl/icons/esm/ui/chevron-up";

var Filters = function Filters(_ref) {
  var title = _ref.title,
      children = _ref.children;
  var getClassName = getClassNameFactory("SearchFiltersFilters");

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setState = _useState2[1];

  var handleToggle = function handleToggle() {
    return setState(!isExpanded);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      states: isExpanded ? "expanded" : ""
    }),
    "data-rehydratable": getRehydratableName(Filters.displayName),
    "data-title": title
  }, /*#__PURE__*/React.createElement("button", {
    className: getClassName({
      descendantName: "title"
    }),
    onClick: handleToggle
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "titleText"
    })
  }, title), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "toggleIcon"
    })
  }, isExpanded ? /*#__PURE__*/React.createElement(ChevronUpIcon, null) : /*#__PURE__*/React.createElement(ChevronDownIcon, null))), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, children));
};

Filters.displayName = "SearchFilters.Filters";
Filters.defaultProps = {
  title: "Narrow by"
};
export default Filters;